module.exports = __webpack_public_path__ + "static/sean-grove.4d287c55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sean-grove.jpg
// module id = 677
// module chunks = 168707334958949